<template>
  <div :class="[`${vertical ? 'divider-vertical' : 'divider-horizontal'}`]" :style="{width: width, height: height, background: `linear-gradient(to ${vertical ? 'right' : 'bottom'}, transparent 0%, ${color} 50%, transparent 100%)`}"></div>
</template>

<script>
export default {
  name: "divider",
  props: {
    vertical: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number | String,
      default: Number(window.localStorage.getItem("fontSize") || 16)
    },
    sizeString: {
      type: String,
      default: ""
    },
    sizeUnit: {
      type: String,
      default: "px"
    },
    color: {
      type: String,
      default: "rgba(0,0,0,.1)"
    }
  },
  computed: {
    width: function() {
      if (!this.vertical) {
        if (this.sizeString !== "") {
          return this.sizeString;
        } else if (typeof this.size !== "number" && this.size > 0) {
          return `${this.size}${this.sizeUnit}`;
        } else {
          return;
        }
      } else {
        return null;
      }
    },
    height: function() {
      if (this.vertical) {
        if (this.sizeString !== "") {
          return this.sizeString;
        } else if (typeof this.size === "number" && this.size > 0) {
          return `${this.size}${this.sizeUnit}`;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/divider.vue